import React from "react";
import { Link } from "react-router-dom";
import { getCurrentLangName } from "helpers/String.helper";

import LoadingComponent from "commons/loading/Loading.component";
import { formatTimeAgo } from "helpers/Datetime.helper";

import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const IndexComponent = (props: any) => {
  const {
    isLoading,
    list,
    onClickCheckNotification,
    limit,
    page,
    setPage,
    hasMore
  } = props;

  return (
    <main className="bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-6 lg:pt-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">
          {getLanguageValue(PAGE_TYPE.STUDENT, "alarmHome.txtTitle")}
        </h2>
        {list &&
          (list.length === 0 ? (
            <div className="flex justify-center items-center h-64">
              <p className="text-gray-500">
                {getLanguageValue(PAGE_TYPE.STUDENT, "alarmHome.txtNoAlarm")}
              </p>
            </div>
          ) : (
            <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
              <div className="space-y-4 p-4">
              {list.map((item: any, index: number) => (
                  item.link ? (
                    <Link
                      key={index}
                      to={item.link}
                      className="flex items-start gap-3 border-b border-gray-100 pb-4 last:border-b-0 last:pb-0 hover:bg-gray-50 rounded-lg p-2 transition-colors duration-200"
                    >
                      <div className="flex-1 min-w-0">
                        <p className={`text-sm break-words mb-2 ${item.isRead ? 'text-gray-900' : 'text-[#CF3688] font-medium'}`}>
                          {getCurrentLangName(item.contents)}
                        </p>
                        <p className="text-xs text-gray-500">
                          {formatTimeAgo(item.createdAt)}
                        </p>
                      </div>
                      <div className="flex items-center gap-2 flex-shrink-0">
                        {!item.isRead && (
                          <div className="w-2.5 h-2.5 rounded-full bg-red-500"></div>
                        )}
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </Link>
                  ) : (
                    <div
                      key={index}
                      onClick={() => onClickCheckNotification(item)}
                      className={`border-b border-gray-100 pb-4 last:border-b-0 last:pb-0 p-2 ${(item.action || item.linkUrl) ? 'cursor-pointer hover:bg-gray-50 rounded-lg transition-colors duration-200' : ''}`}
                    >
                      <div className="flex items-start gap-3">
                        <div className="flex-1 min-w-0">
                          <p className={`text-sm break-words mb-2 ${item.isRead ? 'text-gray-900' : 'text-[#CF3688] font-medium'}`}>
                            {getCurrentLangName(item.contents)}
                          </p>
                          <p className="text-xs text-gray-500">
                            {formatTimeAgo(item.createdAt)}
                          </p>
                        </div>
                        {!item.isRead && (
                          <div className="w-2.5 h-2.5 rounded-full bg-red-500 mt-1 flex-shrink-0"></div>
                        )}
                      </div>
                    </div>
                  )
                ))}
              </div>
            </div>
          ))}
        {isLoading && <LoadingComponent />}
      </div>
    </main>
  );
};

export default IndexComponent;
